import { cn } from "@/shared/lib/cn.js";

/**
 * Tabela. O `overflow-x-auto` fica no wrapper para que uma tabela larga
 * role dentro do próprio bloco, sem empurrar a página inteira para o lado.
 */
export function Table({ className, wrapperClassName, ...props }) {
  return (
    <div className={cn("w-full overflow-x-auto", wrapperClassName)}>
      <table className={cn("w-full caption-bottom text-sm", className)} {...props} />
    </div>
  );
}

export function TableHeader({ className, ...props }) {
  return (
    <thead
      className={cn("bg-muted/40 text-xs uppercase tracking-wider text-muted-foreground", className)}
      {...props}
    />
  );
}

export function TableBody({ className, ...props }) {
  return <tbody className={cn("[&_tr:last-child]:border-0", className)} {...props} />;
}

export function TableRow({ className, ...props }) {
  return (
    <tr
      className={cn("border-t border-border/60 transition-colors hover:bg-muted/30", className)}
      {...props}
    />
  );
}

export function TableHead({ className, ...props }) {
  return <th className={cn("px-4 py-3 text-left font-medium", className)} {...props} />;
}

export function TableCell({ className, ...props }) {
  return <td className={cn("px-4 py-3 align-middle", className)} {...props} />;
}

export function TableCaption({ className, ...props }) {
  return <caption className={cn("mt-4 text-sm text-muted-foreground", className)} {...props} />;
}
